'use client'
import { useState } from 'react'
import PopupComponent from '../popup/popup'
import RenderRichTexComponent from '../rich-text-render/richTextRender'
import ReadMoreSnippetComponent from './read-more-snippet'
import SnippetComponent from './snippet'
interface IProps {
  value?: {
    root: {
      type: string
      children: {
        type: string
        version: number
        [k: string]: unknown
      }[]
      direction: ('ltr' | 'rtl') | null
      format: 'left' | 'start' | 'center' | 'right' | 'end' | 'justify' | ''
      indent: number
      version: number
    }
    [k: string]: unknown
  } | null
  text?: (string | undefined)[] | undefined
  name?: string
  id?: string
}

function countRichTextCharacters({ value }: IProps) {
  const textList = value?.root?.children.filter(
    (child) =>
      typeof child === 'object' &&
      child.hasOwnProperty('children') &&
      Array.isArray(child.children) &&
      child.children.some((x) => x.hasOwnProperty('text')),
  )

  if (textList != undefined && textList?.length > 0) {
    const textBlocks = textList.flatMap((item) => {
      if (typeof item === 'object' && item.hasOwnProperty('children')) {
        if (Array.isArray(item.children)) {
          return item.children.flatMap((x) => {
            if (x.hasOwnProperty('text')) {
              return x.text
            } else if (x.type === 'link') {
              if (x.hasOwnProperty('children') && Array.isArray(x.children)) {
                return x.children[0].text
              }
            }
          })
        }
      }
    })

    return textBlocks
  }
}

export function BasicSnippetComponent({ value, text, name, id }: IProps) {
  const [isPopoverOpen, setPopoverOpen] = useState(false)

  let showReadMore = false
  const characterCount = countRichTextCharacters({ value })?.reduce((acc, curr) => {
    if (typeof curr === 'string') {
      return acc + curr.length
    }
    return acc
  }, 0)
  const numberOfBlocks = value?.root.children?.filter((item) => item.type === 'block').length ? value?.root.children?.filter((item) => item.type === 'block').length : 0
  if (characterCount > 300 || (characterCount > 200 && numberOfBlocks > 0) || (characterCount > 100 && numberOfBlocks > 1)) {
    showReadMore = true
  }

  return (
    <span id={id}>
      <SnippetComponent text={text}>
        <span className={`block`}>
          <span className="block relative text-sm bg-black min-h-9 w-64 p-2 text-white rounded-t-lg right-[1px]">
            <span className="block font-semibold	">{name}</span>
          </span>
          <span id={`snippet-${id}`} className="block px-3 py-2">
            <span
              id={id}
              className={`block font-normal text-sm m-0 snippetText ${
                showReadMore ? '!line-clamp-[12]' : ''
              }`}
            >
              <RenderRichTexComponent richTextField={value} />
            </span>
            {showReadMore && (
              <button
                onClick={() => {
                  setPopoverOpen(true)
                }}
              >
                {showReadMore && <ReadMoreSnippetComponent />}
              </button>
            )}
          </span>
        </span>
      </SnippetComponent>
      {isPopoverOpen && (
        <PopupComponent onClose={() => setPopoverOpen(false)}>
          <span className="block w-[60vw] bg-white rounded-lg text-left">
            <span className="block relative bg-black min-h-9 p-2 text-white rounded-t-lg">
              <span className="!mx-[20px] block font-semibold text-[20px]">{name}</span>
            </span>
            <span className="block px-3 py-2">
              <span className="!mx-[20px] block font-normal text-sm m-0 snippetText">
                <RenderRichTexComponent richTextField={value} textOnly={false} />
              </span>
            </span>
          </span>
        </PopupComponent>
      )}
    </span>
  )
}
